module.exports = __webpack_public_path__ + "img/history.a4382a48.svg";